import React, { Component } from 'react';

class ProjectDescriptionLinkParser {
  constructor(description) {
    this.description = this.normalizeLineEndings(description || '');
  }

  normalizeLineEndings(description) {
    return description.replace(/\r\n?/g, '\n');
  }

  buildSegments() {
    const urlPattern = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
    const segments = [];
    let currentIndex = 0;
    let match;

    while ((match = urlPattern.exec(this.description)) !== null) {
      if (match.index > currentIndex) {
        segments.push(this.buildTextSegment(currentIndex, match.index));
      }

      segments.push(...this.buildUrlSegments(match[0]));
      currentIndex = match.index + match[0].length;
    }

    if (currentIndex < this.description.length) {
      segments.push(
        this.buildTextSegment(currentIndex, this.description.length)
      );
    }

    return segments;
  }

  buildTextSegment(startIndex, endIndex) {
    return {
      type: 'text',
      value: this.description.slice(startIndex, endIndex)
    };
  }

  buildUrlSegments(rawUrl) {
    const trimmedUrl = this.trimTrailingPunctuation(rawUrl);
    const trailingText = rawUrl.slice(trimmedUrl.length);
    const segments = [
      {
        type: 'link',
        value: trimmedUrl,
        href: this.normalizeHref(trimmedUrl)
      }
    ];

    if (trailingText) {
      segments.push({
        type: 'text',
        value: trailingText
      });
    }

    return segments;
  }

  normalizeHref(url) {
    if (url.toLowerCase().indexOf('www.') === 0) {
      return `https://${url}`;
    }

    return url;
  }

  trimTrailingPunctuation(url) {
    return url.replace(/[.,;:!?)]*$/g, '');
  }
}

class ProjectDescription extends Component {
  renderTextSegment(segment, index) {
    return segment.value.split('\n').map((line, lineIndex, lines) => (
      <React.Fragment key={`project-description-text-${index}-${lineIndex}`}>
        {line}
        {lineIndex < lines.length - 1 && <br />}
      </React.Fragment>
    ));
  }

  renderSegment(segment, index) {
    if (segment.type === 'link') {
      return (
        <a
          className="standard__project-description-link"
          href={segment.href}
          key={`project-description-link-${index}`}
          rel="noopener noreferrer"
          target="_blank"
        >
          {segment.value}
        </a>
      );
    }

    return this.renderTextSegment(segment, index);
  }

  render() {
    const parser = new ProjectDescriptionLinkParser(this.props.description);

    return (
      <h4 className="standard__project-main-description">
        {parser
          .buildSegments()
          .map((segment, index) => this.renderSegment(segment, index))}
      </h4>
    );
  }
}

export default ProjectDescription;
